/** ספריות מהעולם Node מניחות `globalThis.process`; ב־Vite רואים `process` את polyfill של `process/browser` */
import processPolyfill from "process";

if (typeof globalThis.process === "undefined") {
  (globalThis as unknown as { process: typeof processPolyfill }).process =
    processPolyfill;
}

import { env } from "@shared/env.config";

env("admin", import.meta.env.MODE);